import React, { useRef, useState } from "react";
import { Transforms } from "slate";
import { useSlateStatic, ReactEditor } from "slate-react";
import { ELEMENT_IMAGE } from "./Post/platePlugins";
import ImageDialog from "./ImageDialog";
import "./LinkButton.css"; // 使用相同的工具欄樣式

const ImageButton = ({ className = "toolbar-button", disabled = false }) => {
  const editor = useSlateStatic();
  const savedSelection = useRef(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  /**
   * 打開圖片插入對話框
   */
  const handleButtonClick = () => {
    savedSelection.current = editor.selection; // 保存當前光標位置
    setIsDialogOpen(true);
  };

  /**
   * 插入圖片節點
   */
  const insertImage = (url) => {
    console.log('插入圖片節點:', { url: url.substring(0, 100) + '...', type: ELEMENT_IMAGE }); // 調試信息
    
    if (savedSelection.current) {
      Transforms.select(editor, savedSelection.current);
    }

    const imageNode = {
      type: ELEMENT_IMAGE,
      url,
      width: 400,
      height: 300,
      children: [{ text: "" }], // void element 仍需要 children
    };

    // 插入圖片節點
    Transforms.insertNodes(editor, imageNode);
    
    // 在圖片後插入空段落以便游標定位
    const paragraphNode = {
      type: 'p',
      children: [{ text: '' }],
    };
    
    Transforms.insertNodes(editor, paragraphNode);
    
    // 移動游標到新段落
    Transforms.move(editor, { distance: 1 });
    
    ReactEditor.focus(editor);
  };

  /**
   * 處理圖片插入
   */
  const handleImageInsert = (imageUrl) => {
    insertImage(imageUrl);
    setIsDialogOpen(false);
  };

  /**
   * 關閉對話框
   */
  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <button
        type="button"
        onMouseDown={(e) => {
          if (disabled) return;
          e.preventDefault();
          handleButtonClick();
        }}
        className={className}
        aria-label="插入圖片"
        disabled={disabled}
      >
        🖼️ 插入圖片
      </button>
      <ImageDialog
        isOpen={isDialogOpen}
        onClose={handleDialogClose}
        onInsert={handleImageInsert}
      />
    </>
  );
};

export default ImageButton;
